import { AutoWebViewJs } from "../../AutoWebViewJs"


let script = `com.fanfanlo.lib.sys.Sys.killMyApp()`
export function appKillSelf(){
    AutoWebViewJs.instance.callScript(script)
}